<template>
  <header class="header">
    <router-link class="header__app-link" to="/">
      <h1 class="header__app-name">
        Tryout Map
      </h1>
    </router-link>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
    <div class="user">
      <slot name="user"></slot>
    </div>
  </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.header {
  align-items: center;
  display: flex;
  padding: min(5vw, 3rem);

  &__app-link {
    flex: 1;
    outline: 0;
    text-decoration: none;
  }

  &__app-name {
    font-size: 2rem;
    font-weight: 400;
  }
}
</style>
